import React from "react"

type AuthPageProps = {
  children: React.ReactNode
}

const AuthPage: React.FC<AuthPageProps> = ({ children }) => (
  <div className="w-full flex min-h-[calc(100vh-150px)] flex-col items-center justify-center py-12 md:py-16 bg-gray-50 dark:bg-gray-800">
    {children}
  </div>
)

export default AuthPage
